<template>
  <basic-container>
    <avue-crud 
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad">
      
      <div slot="menuLeft">
        <el-button 
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permissionList.delBtn"
          @click="handleDelete">
          批量删除
        </el-button>
      </div>
      
      <template slot-scope="{row}" slot="file">
             <el-upload
              class="upload-demo"
              action=""
              :http-request="uploadFile"
              :limit="1"
              :on-change="handleFileChange"
              :on-remove="handleFileRemove"
              :file-list="fileList"
              accept=".txt,.log">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传txt/log文件</div>
            </el-upload>
      </template>

    </avue-crud>
  </basic-container>
</template>

<script>
import {
  getProgressList, 
  getProgressDetail, 
  addProgress, 
  updateProgress, 
  updateProgressNoFile,
  deleteProgress,
  batchDeleteProgress 
} from "@/api/ad/progress";
import { mapGetters } from "vuex";

export default {
  name: 'Progress',
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      fileList: [],
      currentFile: null,
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        labelWidth: 120,
        labelPosition: 'right',
        span: 24, // Use full width for form items generally
        column: [
          {
            label: "ID",
            prop: "id",
            span: 24,
            addDisplay: false,
            editDisplay: false,
            search: false,
          },
          {
            label: "名称",
            prop: "name",
            span: 24,
            search: true,
            rules: [{
              required: true,
              message: "请输入名称",
              trigger: "blur"
            }, {
              max: 30,
              message: "名称不能超过30个字符",
              trigger: "blur"
            }]
          },
          {
            label: "是否默认",
            prop: "progressType",
            span: 24,
            type: "radio",
            search: false,
            dicData: [
              {
                label: "否",
                value: 1
              },
              {
                label: "是",
                value: 0
              }
            ],
            rules: [{
              required: true,
              message: "请选择是否默认",
              trigger: "change"
            }]
          },
          {
            label: "文件",
            prop: "file",
            span: 24,
            formslot: true, // Use form slot for file input
            hide: true, // Hide in table
            rules: [{
                required: false, // Handled manually
                message: "请上传文件",
                trigger: "change"
            }]
          },
          {
             label: "数据下载",
             prop: "download",
             hide: false,
             addDisplay: false,
             editDisplay: false,
             viewDisplay: false,
             slot: true
          },
          {
            label: "添加人",
            prop: "updateuser",
            span: 24,
            addDisplay: false,
            editDisplay: false,
            search: false,
          },{
            label: "添加时间",
            prop: "updatetime",
            span: 24,
            addDisplay: false,
            editDisplay: false,
            search: false,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          }
        ]
      },
      data: []
    };
  },
  
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.progress_add, true),
        viewBtn: this.vaildData(this.permission.progress_view, true),
        delBtn: this.vaildData(this.permission.progress_delete, true),
        editBtn: this.vaildData(this.permission.progress_edit, true)
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  
  mounted() {
    // this.onLoad(this.page); // avue-crud triggers onLoad initially
  },
  
  methods: {
    // Custom file upload handler to simply capture the file
    uploadFile(param) {
        this.currentFile = param.file;
    },
    handleFileChange(file, fileList) {
        this.fileList = fileList.slice(-1);
        this.currentFile = file.raw;
    },
    handleFileRemove(file, fileList) {
        this.fileList = [];
        this.currentFile = null;
    },

    // 行保存（新增）
    rowSave(row, loading, done) {
      if (!this.currentFile) {
          this.$message.error("请上传文件");
          done();
          return;
      }
      
      const formData = new FormData();
      // Only include specific fields, or iterate row
      const adProgress = {
          name: row.name,
          progressType: row.progressType
      };
      
      // We need to send adProgress as a JSON blob part if using @RequestPart("adProgress")
      // OR map fields individually if the backend expects @RequestParam for fields.
      // The backend structure uses @RequestPart("adProgress") which expects JSON content type for that part
      
      const jsonBlob = new Blob([JSON.stringify(adProgress)], { type: 'application/json' });
      formData.append('adProgress', jsonBlob);
      formData.append('file', this.currentFile);
      
      addProgress(formData).then(res => {
        if (res.data.code === 200) {
          loading();
          this.onLoad(this.page);
          this.$message.success("新增成功!");
          this.fileList = [];
          this.currentFile = null;
          done();
        } else {
          done();
          this.$message.error(res.data.msg || "新增失败");
        }
      }).catch(error => {
        done();
        console.log(error);
        this.$message.error("新增失败，请重试");
      });
    },
    
    // 行更新（编辑）
    rowUpdate(row, index, loading, done) {
      const adProgress = {
        id: row.id,
        name: row.name,
        progressType: row.progressType
      };

      if (this.currentFile) {
          // Update with file
          const formData = new FormData();
          const jsonBlob = new Blob([JSON.stringify(adProgress)], { type: 'application/json' });
          formData.append('adProgress', jsonBlob);
          formData.append('file', this.currentFile);
          
          updateProgress(formData).then(res => {
            if (res.data.code === 200) {
              loading();
              this.onLoad(this.page);
              this.$message.success("更新成功!");
              this.fileList = [];
              this.currentFile = null;
              done();
            } else {
              done();
              this.$message.error(res.data.msg || "更新失败");
            }
          }).catch(error => {
            done();
            this.$message.error("更新失败");
          });
      } else {
          // Update without file
          updateProgressNoFile(adProgress).then(res => {
             if (res.data.code === 200) {
              loading();
              this.onLoad(this.page);
              this.$message.success("更新成功!");
              done();
            } else {
              done();
              this.$message.error(res.data.msg || "更新失败");
            }
          }).catch(error => {
            done();
            this.$message.error("更新失败");
          });
      }
    },
    
    // 行删除
    rowDel(row) {
      this.$confirm("确定要删除这条刻度数据吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        return deleteProgress(row.id);
      }).then(res => {
        if (res.data.code === 200) {
          this.onLoad(this.page);
          this.$message.success("删除成功!");
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      });
    },
    
    // 批量删除
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定要删除选中的刻度数据吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        return batchDeleteProgress(this.ids);
      }).then(res => {
        if (res.data.code === 200) {
          this.onLoad(this.page);
          this.$message.success("批量删除成功!");
          this.$refs.crud.toggleSelection();
        } else {
          this.$message.error(res.data.msg || "批量删除失败");
        }
      });
    },
    
    // 打开前处理
    beforeOpen(done, type) {
      this.fileList = [];
      this.currentFile = null;
      if (["edit", "view"].includes(type)) {
        getProgressDetail(this.form.id).then(res => {
          if (res.data.code === 200) {
            this.form = res.data.data;
          }
        });
      }
      done();
    },
    
    // 搜索重置
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    
    // 搜索变化
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, this.query);
      done();
    },
    
    // 选择变化
    selectionChange(list) {
      this.selectionList = list;
    },
    
    // 当前页变化
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    
    // 页大小变化
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    
    // 刷新
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    
    // 加载数据
    onLoad(page, params = {}) {
      this.loading = true;
      const requestData = {
        current: page.currentPage,
        size: page.pageSize,
        ...params
      };
      
      getProgressList(requestData).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(res.data.msg || "获取数据失败");
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error("获取数据失败，请重试");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>